<template>
    <div class="tabs-pane" v-show="active() == keyword">
        <slot></slot>
    </div>
</template>

<script>
var _randomId = parseInt(Math.random()*10000) + '-' + new Date().getTime()
export default {
    name: 'tabs-pane',
    inject: ['addBar','removeBar','setBar','active'],
    props: {
        label: {
            type: String | Number,
            default: 'Tab'
        },
        keyword: String | Number
    },
    data: ()=>({
        
    }),
    mounted () {
        this.addBar && this.addBar({
            _id: _randomId,
            value: this.label,
            keyword: this.keyword
        })
    },
    updated () {
        this.setBar && this.setBar({
            _id: _randomId,
            value: this.label,
            keyword: this.keyword
        })
    },
    destroyed () {
        this.removeBar && this.removeBar(_randomId)
    }
}
</script>

<style scoped>
.tabs-pane{
    background: rgb(247, 248, 250);
    padding: 10px;
    padding-bottom: 0;
    position: relative;
}
</style>